import React, { useEffect, useState } from 'react';
import { countriesForFamily, loadPublicEsimCatalogue } from '@/lib/publicEsimCatalogue';

const TravelEsimDestinations = ({ catalogue }) => {
  const [resolvedCatalogue, setResolvedCatalogue] = useState(catalogue);

  useEffect(() => {
    if (catalogue) {
      setResolvedCatalogue(catalogue);
      return undefined;
    }

    let active = true;
    loadPublicEsimCatalogue()
      .then((loadedCatalogue) => {
        if (active) setResolvedCatalogue(loadedCatalogue);
      })
      .catch(() => {
        // The buying selectors already surface catalogue availability errors.
        // This crawlable summary remains hidden when the authoritative source is unavailable.
      });

    return () => {
      active = false;
    };
  }, [catalogue]);

  const destinations = countriesForFamily(resolvedCatalogue, 'travel')
    .map((country) => country.label)
    .sort((left, right) => left.localeCompare(right, 'en-GB'));

  if (destinations.length === 0) return null;

  return (
    <section id="travel-esim-destinations" className="travel-esim-destinations" aria-labelledby="travel-esim-destinations-title">
      <div>
        <p className="travel-esim-destinations-kicker">CURRENT DESTINATIONS</p>
        <h2 id="travel-esim-destinations-title">Travel eSIM destinations</h2>
        <p>Choose a supported destination in the Travel Packs section to see its currently available data and duration options.</p>
        <ul aria-label="Supported PhantomPath travel eSIM destinations">
          {destinations.map((destination) => <li key={destination}>{destination}</li>)}
        </ul>
        <a href="/#travel-packs">Choose your destination and plan</a>
      </div>
    </section>
  );
};

export default TravelEsimDestinations;
